export const backendBaseUrl = "https://connect.eqarcom.ae";
export const backendIntegrationBaseUrl = "https://integration.eqarcom.ae";
export const dashboardBaseUrl = "";
